import { BreadCrumbs } from "@alliancesafetycouncil/asc-breadcrumbs";
import PageTitle from "@alliancesafetycouncil/asc-page-title";
import React, { Component } from "react";
import { connect } from "react-redux";
import { getCompany } from "../../../actions/Companies/Companies";
import FormContainer from "../../../components/FormContainer/FormContainer";
import { HeaderActions } from "../../../components/HeaderActions/HeaderActions";
import { Header } from "../../../containers/Layout/Header";
import EditCompanyForm from "./EditCompanyForm";

class EditCompany extends Component {
  constructor(props) {
    super(props);

    this.state = {
      companyId: props.match.params.id,
    };
  }

  setRef = (ref) => {
    this.setState({
      editorRef: ref,
    });
  };

  componentDidMount() {
    this.props.GetCompany(this.state.companyId);
  }

  render() {
    const { details } = this.props;

    const links = [
      {
        title: details.name,
        link: "/#/companies",
      },
      {
        title: "Edit Company",
      },
    ];

    return (
      <div className="flex flex-col bg-blue-50 h-full">
        <Header>
          <div className="pr-6 w-4/6">
            <BreadCrumbs crumbs={links} />
          </div>
          <div className="w-2/6">{this.props.auth && <HeaderActions />}</div>
        </Header>
        <div className="row header no-flex mx-4 h-20 flex items-center">
          <PageTitle>
            <i className="fal fa-building text-orange-500 mr-2"></i>Edit Company
          </PageTitle>
        </div>
        <div className="mb-4 content flex-auto mx-4">
          <FormContainer
            {...this.props}
            setRef={this.setRef}
            entity="companies"
            action="edit"
            redirect={`/companies`}
            Form={EditCompanyForm}
            handleValues={(values) => {
              return {
                ...values,
                notes: this.state.editorRef.getContent(),
              };
            }}
            initialValues={{
              notes: details.notes,
              name: details.name,
              contact: details.contact,
            }}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    details: state.companyService.details,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    GetCompany: (id) => dispatch(getCompany(id)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(EditCompany);
